import React, { useState } from 'react'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import RegisterSuccess from './RegisterSuccess'

const RegisterVerify = ({ email }) => {
    const [verified, setVerified] = useState(false)
    const history = useHistory()
    const initialValues = {
        verification_code: '',
    }
    const validationArray = Yup.object({
        verification_code: Yup.string().required('Please enter your verification code'),
    })
    const formData = [
        {
            label: 'Verification Code',
            name: 'verification_code',
            type: 'text',
            placeholder: 'Enter verification code',
            class: 'col-12',
        },
    ]

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationArray,
        onSubmit: (values) => {
            setVerified(true)
        },
    })

    const verifyInfo = {
        formik: formik,
        data: formData,
    }

    return verified ? (
        <RegisterSuccess />
    ) : (
        <div className="register-verify-wrapper">
            <h4>To create a Zipperbuy account you need to Verify your email address</h4>
            <p>
                We already sen a code to {email}, please check your inbox and insert the code in
                form below to verify your email.
            </p>

            <form onSubmit={formik.handleSubmit}>
                <div className="row">{Object.values(mapData(verifyInfo))}</div>
                <div className="send-code">
                    <a>Send a new code</a>
                </div>
                <PrimaryButton id="verify_button" label="Verify" type="submit" />
            </form>
        </div>
    )
}

export default RegisterVerify
